import { useSelector } from "react-redux"

import { cn } from "styles/utils"

const Badge = () => {
  const badgeLabel = useSelector(
    (state) =>
      state.wizard.badge?.label ??
      (state.wizard.price_and_promo?.on_sale && "Sale")
  )
  const currentSlideIndex = useSelector(
    (state) => state.previewImage.slideIndex
  )
  const { className: secondMicroBannerClassName, ...secondMicroBannerProps } =
    useSelector((state) => state.sale.second_microbanner?.style) || {}

  if (!badgeLabel) return null

  return (
    <div
      className={cn(
        "bg-light-pink text-black-print text-13 h-18 flex min-w-80 items-center justify-center px-12 font-semibold transition-opacity",
        currentSlideIndex === 0 ? "" : "opacity-0",
        secondMicroBannerClassName
      )}
      {...secondMicroBannerProps}
    >
      {badgeLabel}
    </div>
  )
}

export default Badge
